import { render, staticRenderFns } from "./AnnouncementTable.vue?vue&type=template&id=b0e0a452&scoped=true&"
import script from "./AnnouncementTable.vue?vue&type=script&lang=js&"
export * from "./AnnouncementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e0a452",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0e0a452')) {
      api.createRecord('b0e0a452', component.options)
    } else {
      api.reload('b0e0a452', component.options)
    }
    module.hot.accept("./AnnouncementTable.vue?vue&type=template&id=b0e0a452&scoped=true&", function () {
      api.rerender('b0e0a452', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/LiveStream/Announcements/Includes/AnnouncementTable.vue"
export default component.exports